import { useRouter } from 'vue-router'
import DropdownAbsolute from '@/views/shared-components/DropdownAbsolute.vue'
import {
  useStore
} from 'vuex'
import { onMounted, defineComponent } from 'vue'
import InlineSvg from 'vue-inline-svg'
import environment from '@/configs/environtment'
import { generateCodeChallenge, generateCodeVerifier } from '@/composables/pages/auth/pkce'

export default defineComponent({
  name: 'ProfileDropdown',
  components: {
    DropdownAbsolute,
    InlineSvg
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    // console.log('anyy', store.state.token)
    const logout = () => {
      const idToken = localStorage.getItem('it')
      store.dispatch('logoutAccount')
      const ssoBaseUrl = environment.getSsoBaseUrl()
      const ssoRealms = environment.getSsoRealms()
      const clientId = environment.getSsoClientId()
      const logoutRedirectUri = environment.getSsoLogoutRedirectUri()

      if (idToken && ssoBaseUrl && ssoRealms) {
        const params = new URLSearchParams({
          id_token_hint: idToken,
          post_logout_redirect_uri: logoutRedirectUri,
          client_id: clientId
        })
        window.location.href = `${ssoBaseUrl}/realms/${ssoRealms}/protocol/openid-connect/logout?${params.toString()}`
      } else {
        window.location.href = '/'
      }
    }

    const toProfilAgen = () => {
      router.push({ name: 'profil-agen' })
    }

    const changePassword = async () => {
      // store.dispatch('setToogleChangePasswordDialog', true)
      console.log('state', store.state)
      const verifier = generateCodeVerifier()
      const challenge = await generateCodeChallenge(verifier)

      const params = new URLSearchParams({
        response_type: `${environment.getSsoResponseType()}`,
        client_id: `${environment.getSsoClientId()}`,
        redirect_uri: `${environment.getSsoRedirectUri()}`,
        code_challenge: challenge,
        code_challenge_method: `${environment.getSsoCodeChallengeMethod()}`,
        scope: `${environment.getSsoScope()}`,
        kc_action: 'UPDATE_PASSWORD'
      })
      window.location.href = `${environment.getSsoBaseUrl()}/realms/${environment.getSsoRealms()}/protocol/openid-connect/auth?${params.toString()}`
    }

    const reload = () => {
      window.location.reload()
    }

    onMounted(() => {
      // store.dispatch('fetchProfile')
    })

    return {
      logout,
      changePassword,
      reload,
      toProfilAgen
    }
  }
})
